// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3BqN0","wrapper":"styles_wrapper__1QKxi","header":"styles_header__16E2g","text":"styles_text__3n72E","ctaButton":"styles_ctaButton__22cyH"};